export enum SharedApiUrl {
    ChatGeneral = '/chat/general/by-country',
    ChatAvatarGeneral = '/avatar/chat/general/by-country',
    NegotiateWebsocketUrl = '/websocket/negotiate',
    GeneralPredefinedPrompts = '/prompt/group/all',
    PredefinedPromptsByRole = '/prompt/role/all',
    DownloadBlobFile = '/document/download',
}
